import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  @media screen and (max-width: 800px) {
    display: ${({ searchOpen }) => (searchOpen ? 'block' : 'none')};
    margin-bottom: 0.5rem;
    grid-column: 1/-1;
    grid-row: 2;
  }
`;

export const SearchIcon = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 1.5rem;
  height: 100%;
  font-size: 2.4rem;
  color: var(--grey);
`;

export const SearchField = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  position: relative;
  font-size: 2rem;
  padding: 1rem 2rem 1rem 5.5rem;
  border: 1px solid #e1e1e1;
  border-radius: 30px;
  outline: none;
  transition: all 0.2s;
  &:focus {
    border-color: var(--accent);
    & + ${SearchIcon} {
      color: var(--accent);
    }
  }
`;
